import axios from 'axios';
import BASE_URL from '../config';
import { getToken, clearAllCookies } from '../../utils/cookies';
import { showSessionExpired } from '../../utils/sessionUtils';

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isShowingExpiredMessage = false;
API.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 ||
      error.response?.status === 401 ||
      error.response?.data?.detail?.includes('admin access required') ||
      error.response?.data?.detail?.includes('access denied')) {

      if (!isShowingExpiredMessage) {
        isShowingExpiredMessage = true;

        clearAllCookies();

        showSessionExpired();

        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

export default API;
